<template>
	<div>
		<ProgressLinear v-if="match_codes_loading"/>
		<v-alert dense class="mx-3 mt-3" type="error" v-if="error_msg.length !== 0">
			{{ errorMessageFormat(error_msg) }}
		</v-alert>
		<template v-if="!match_codes_loading">
			<v-row class="mx-4 mt-5 mb-0 file-list-text" style="color: #4742C6">JobBag Job numbers</v-row>
			<v-row v-for="item in file_detail_products.filter(product => { return product.is_default_hide === false})" :key="`product_${item.id}`" class="mx-1" :class="$vuetify.breakpoint.mdAndDown ? 'my-3':''" align="start">
				<v-col :cols="$vuetify.breakpoint.mdAndDown ? 12:2" :class="$vuetify.breakpoint.mdAndDown ? 'py-2':'py-0'">
					<div class="file-list-text">Radio Holdings Product</div>
					<div class="file-list-title">{{ item.code }} - {{ item.description }}</div>
				</v-col>
				<v-col :cols="$vuetify.breakpoint.mdAndDown ? 12:3" class="py-0">
					<div class="file-list-text">JobBag Job code and name</div>
					<v-autocomplete
						:key="`product_search_${item.id}`"
						:value="item.job_link.job"
						:items="item.job_items"
						:color="color"
						:prepend-inner-icon="item.job_link.job !== null ? '':'mdi-magnify'"
						:append-icon="''"
						:error="item.no_data"
						:error-messages="item.no_data ? error_message : ''"
						placeholder="Type to search JobBag Jobs"
						background-color="#FAFAFA"
						item-text="display_name"
						item-value="id"
						item-color=""
						item-disabled="disabled"
						outlined
						dense
						hide-no-data
						return-object
						clearable
						@update:search-input="onJobSearch($event, item)"
						@change="onJobChange($event, item)"
					>
						<template v-slot:prepend-inner>   
							<SuitCase :color="item.no_data ? '#F45252':'rgba(25, 42, 62, 0.5)'" width="24" height="24"/>
						</template>
					</v-autocomplete>
				</v-col>
				<v-col :cols="$vuetify.breakpoint.mdAndDown ? 12:2" :class="$vuetify.breakpoint.mdAndDown ? 'py-0':'pt-2 pb-0'" align-self="center">
					<v-btn
						v-if="item.job_link.link_id === null"
						class="save-btn file-list-text text-capitalize white--text px-3"
						:color="color"
						:disabled="item.job_link.job === null"
						min-width="112"
						depressed
						@click="onJobProductLink(item)"
					>
						<span>Save match</span>
					</v-btn>
					<v-btn
						v-if="item.job_link.link_id !== null && (!item.job_link.job || (item.job_link.job && item.job_link.job.id !== item.job_link_orginal.job.id))"
						class="save-btn file-list-text text-capitalize white--text px-3"
						:color="color"
						:disabled="!(item.job_link && item.job_link.job && item.job_link.job.id !== item.job_link_orginal.job.id)"
						min-width="112"
						depressed
						@click="onUpdateJobProductLink(item)"
					>
						<span>Save match</span>
					</v-btn>
				</v-col>
			</v-row>
			<v-btn
				class="text-capitalize mx-2 my-2 px-2"
				max-height="40"
				min-height="40"
				:color="color"
				text
				@click="show_products = !show_products"
			>
				<HideIcon v-if="show_products" :color="color" width="20" height="20" class="mr-2"/>
				<UnhideIcon v-else :color="color" width="20" height="20" class="mr-2"/>
				<span v-if="show_products" class="font-bold-style">Show all</span>
				<span v-else class="font-bold-style">Hide all</span>
			</v-btn>
			<template v-if="show_products">
				<v-row v-for="item in file_detail_products.filter(product => { return product.is_default_hide === true})" :key="`product_${item.id}`" class="mx-1" :class="$vuetify.breakpoint.mdAndDown ? 'my-3':''" align="start">
					<v-col :cols="$vuetify.breakpoint.mdAndDown ? 12:2" :class="$vuetify.breakpoint.mdAndDown ? 'py-2':'py-0'">
						<div class="file-list-text">Radio Holdings Product</div>
						<div class="file-list-title">{{ item.code }} - {{ item.description }}</div>
					</v-col>
					<v-col :cols="$vuetify.breakpoint.mdAndDown ? 12:3" class="py-0">
						<div class="file-list-text">JobBag Job code and name</div>
						<v-autocomplete
							:key="`product_search_${item.id}`"
							:value="item.job_link.job"
							:items="item.job_items"
							:color="color"
							:prepend-inner-icon="item.job_link.job !== null ? '':'mdi-magnify'"
							:append-icon="''"
							:error="item.no_data"
							:error-messages="item.no_data ? error_message : ''"
							placeholder="Type to search JobBag Jobs"
							background-color="#FAFAFA"
							item-text="display_name"
							item-value="id"
							item-color=""
							item-disabled="disabled"
							outlined
							dense
							hide-no-data
							return-object
							clearable
							@update:search-input="onJobSearch($event, item)"
							@change="onJobChange($event, item)"
						>
						</v-autocomplete>
					</v-col>
					<v-col :cols="$vuetify.breakpoint.mdAndDown ? 12:2" :class="$vuetify.breakpoint.mdAndDown ? 'py-0':'pt-2 pb-0'" align-self="center">
						<v-btn
							v-if="item.job_link.link_id === null"
							class="save-btn file-list-text text-capitalize white--text px-3"
							:color="color"
							:disabled="item.job_link.job === null"
							min-width="112"
							depressed
							@click="onJobProductLink(item)"
						>
							<span>Save match</span>
						</v-btn>
						<v-btn
							v-if="item.job_link.link_id !== null && (!item.job_link.job || (item.job_link.job && item.job_link.job.id !== item.job_link_orginal.job.id))"
							class="save-btn file-list-text text-capitalize white--text px-3"
							:color="color"
							:disabled="!(item.job_link && item.job_link.job && item.job_link.job.id !== item.job_link_orginal.job.id)"
							min-width="112"
							depressed
							@click="onUpdateJobProductLink(item)"
						>
							<span>Save match</span>
						</v-btn>
					</v-col>
				</v-row>
			</template>
		</template>
		<template v-if="!match_codes_loading">
			<v-row class="mx-4 mt-7 mb-0 file-list-text" style="color: #4742C6">Media Outlets </v-row>
			<v-row v-for="item in file_detail_stations.filter(station => { return station.is_default_hide === false })" :key="`station_${item.id}`" class="mx-1" align="start">
				<v-col :cols="$vuetify.breakpoint.mdAndDown ? 12:2" class="py-0">
					<div class="file-list-text">Radio Holdings Station</div>
					<div class="file-list-title">{{ item.code }} - {{ item.description }}</div>
				</v-col>
				<v-col :cols="$vuetify.breakpoint.mdAndDown ? 12:3" class="py-0">
					<div class="file-list-text">JobBag Media Outlet</div>
					<v-autocomplete
						:key="`product_search_${item.id}`"
						:value="item.media_supplier"
						:items="item.supplier_items"
						:color="color"
						:prepend-inner-icon="item.media_supplier !== null ? '':'mdi-magnify'"
						:append-icon="''"
						:error="item.no_data"
						:error-messages="item.no_data ? error_message : ''"
						placeholder="Type to search Media Outlet"
						background-color="#FAFAFA"
						item-text="display_name"
						item-value="id"
						item-color=""
						item-disabled="disabled"
						outlined
						dense
						hide-no-data
						return-object
						clearable
						@update:search-input="onSupplierSearch($event, item)"
						@change="onSupplierChange($event, item)"
					>
					</v-autocomplete>
				</v-col>
				<v-col :cols="$vuetify.breakpoint.mdAndDown ? 12:2" class="pt-2 pb-0"  align-self="center">
					<v-btn
						v-if="!item.media_supplier_link || (item.media_supplier_link && !item.media_supplier_link.media_supplier)"
						class="save-btn file-list-text text-capitalize white--text px-3" 
						:color="color" 
						:disabled="item.media_supplier === null"
						min-width="112"
						depressed
						@click="onStationLink(item)"
					>
						<span>Save match</span>
					</v-btn>
					<v-btn
						v-if="item.media_supplier_link && item.media_supplier_link.media_supplier && (!item.media_supplier || (item.media_supplier && item.media_supplier_link && item.media_supplier_link.media_supplier &&  item.media_supplier.id !== item.media_supplier_link.media_supplier.id))"
						class="save-btn file-list-text text-capitalize white--text px-3" 
						:color="color" 
						:disabled="!(item.media_supplier && item.media_supplier_link && item.media_supplier_link.media_supplier && item.media_supplier.id !== item.media_supplier_link.media_supplier.id)"
						min-width="112"
						depressed
						@click="onUpdateStationLink(item)"
					>
						<span>Save match</span>
					</v-btn>
				</v-col>
			</v-row>
			<v-btn
				class="text-capitalize mx-2 my-2 px-2"
				max-height="40"
				min-height="40"
				:color="color"
				text
				@click="show_stations = !show_stations"
			>
				<HideIcon v-if="show_stations" :color="color" width="20" height="20" class="mr-2"/>
				<UnhideIcon v-else :color="color" width="20" height="20" class="mr-2"/>
				<span v-if="show_stations" class="font-bold-style">Show all</span>
				<span v-else class="font-bold-style">Hide all</span>
			</v-btn>
			<template v-if="show_stations">
				<v-row v-for="item in file_detail_stations.filter(station => { return station.is_default_hide === true })" :key="`station_${item.id}`" class="mx-1" align="start">
					<v-col :cols="$vuetify.breakpoint.mdAndDown ? 12:2" class="py-0">
						<div class="file-list-text">Radio Holdings Station</div>
						<div class="file-list-title">{{ item.code }} - {{ item.description }}</div>
					</v-col>
					<v-col :cols="$vuetify.breakpoint.mdAndDown ? 12:3" class="py-0">
						<div class="file-list-text">JobBag Media Outlet</div>
						<v-autocomplete
							:key="`product_search_${item.id}`"
							:value="item.media_supplier"
							:items="item.supplier_items"
							:color="color"
							:prepend-inner-icon="item.media_supplier !== null ? '':'mdi-magnify'"
							:append-icon="''"
							:error="item.no_data"
							:error-messages="item.no_data ? error_message : ''"
							placeholder="Type to search Media Outlet"
							background-color="#FAFAFA"
							item-text="display_name"
							item-value="id"
							item-color=""
							item-disabled="disabled"
							outlined
							dense
							hide-no-data
							return-object
							clearable
							@update:search-input="onSupplierSearch($event, item)"
							@change="onSupplierChange($event, item)"
						>
						</v-autocomplete>
					</v-col>
					<v-col :cols="$vuetify.breakpoint.mdAndDown ? 12:2" class="pt-2 pb-0"  align-self="center">
						<v-btn
							v-if="!item.media_supplier_link || (item.media_supplier_link && !item.media_supplier_link.media_supplier)"
							class="save-btn file-list-text text-capitalize white--text px-3" 
							:color="color" 
							:disabled="item.media_supplier === null"
							min-width="112"
							depressed
							@click="onStationLink(item)"
						>
							<span>Save match</span>
						</v-btn>
						<v-btn
							v-if="item.media_supplier_link && item.media_supplier_link.media_supplier && (!item.media_supplier || (item.media_supplier && item.media_supplier_link && item.media_supplier_link.media_supplier &&  item.media_supplier.id !== item.media_supplier_link.media_supplier.id))"
							class="save-btn file-list-text text-capitalize white--text px-3" 
							:color="color" 
							:disabled="!(item.media_supplier && item.media_supplier_link && item.media_supplier_link.media_supplier && item.media_supplier.id !== item.media_supplier_link.media_supplier.id)"
							min-width="112"
							depressed
							@click="onUpdateStationLink(item)"
						>
							<span>Save match</span>
						</v-btn>
					</v-col>
				</v-row>
			</template>
		</template>
		<NoticeConfirmDialog
			v-if="visible_notice" 
			:visible="visible_notice" 
			:text="notice_text"
			:color="notice_color"
			@ok="close()"
		/>
	</div>
</template>

<script>
import ProgressLinear from "@/components/progress/progress_getdata_linear.vue";
import HideIcon from "@/components/icons/hide.vue";
import UnhideIcon from "@/components/icons/unhide.vue";
import SuitCase from "@/components/icons/suitcase.vue";
import NoticeConfirmDialog from "@/components/dialogs/notice_confirm_dialog.vue";

const Error_Flag = 'Traffic;';
const DescriptionLimit = 60;
const ErrorMessage = 'No matches found. Please create this in the Jobs window to continue.';
const Exist_Text = 'Link already exists.';

export default {
	name: 'MediaHoldingMatchCode',
	props: {
		color: {
			type: String,
			default: ''
		},
		fileId: {
			type: Number,
			default: 0
		}
	},
	data() {
		return {
			error_message: ErrorMessage,
			match_codes_loading: false,
			error_msg: '',

			file_detail: null,
			file_detail_products: [],
			file_detail_stations: [],

			show_products: false,
			show_stations: false,

			visible_notice: false,
			notice_text: [],
			notice_color: '#00AAFD',
		}
	},
	components: {
		ProgressLinear,
		HideIcon,
		UnhideIcon,
		SuitCase,
		NoticeConfirmDialog
	},
	created() {
		this.getForMatches(this.fileId);
	},
	computed: {
	},
	watch: {
		file_detail() {
			if (this.file_detail !== null) {
				this.$emit('tab-able', true)
			}
		}
	},
	methods: {		
		getForMatches(file_id, clicked_item = null) {
			if (!clicked_item) {
				this.match_codes_loading = true;
			}

			const url = `/api/media/media_planning/import_export/${file_id}/for_matches`;
			axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const {status, data, reason } = val.data;
					if (status == "OK") {
						if (clicked_item) {
							const product = data[0].products && data[0].products
								.find(item => item.id === clicked_item.id);
							if (product && clicked_item.job_link !== undefined) {
								product['job_items'] = product.job_link.job ? [product.job_link.job] : [];
								product['job_items'].forEach(item => {
									item['display_name'] = `${item.code} - ${item.display_name}`;
								});

								this.$set(clicked_item, 'job_link', product.job_link);
								this.$set(clicked_item, 'job_items', product.job_items);
								this.$set(clicked_item, 'job_link_orginal', JSON.parse(JSON.stringify(product.job_link)));
								this.$set(clicked_item, 'no_data', false);
								this.$set(clicked_item, 'is_default_hide', true);
								return;
							}

							const station = data[0].stations && data[0].stations
								.find(item => item.id === clicked_item.id);
							if (station) {
								station['supplier_items'] = station.media_supplier_link
									? [station.media_supplier_link.media_supplier]
									: [];
								station['media_supplier'] = station.media_supplier_link
									? station.media_supplier_link.media_supplier
									: null;

								this.$set(clicked_item, 'media_supplier_link', station.media_supplier_link);
								this.$set(clicked_item, 'supplier_items', station.supplier_items);
								this.$set(clicked_item, 'media_supplier', station.media_supplier);
								this.$set(clicked_item, 'no_data', false);
								this.$set(clicked_item, 'is_default_hide', true);
							}
							return;
						}

						this.file_detail = data[0];

						if (data[0].products) {
							const products = data[0].products;

							products.forEach(prod => {
								prod['job_items'] = prod.job_link.job ? [prod.job_link.job] : [];
								prod['job_items'].forEach(item => {
									item['display_name'] = `${item.code} - ${item.display_name}`
								});
								prod['job_link_orginal'] = JSON.parse(JSON.stringify(prod.job_link));
								prod['no_data'] = false;
								prod['is_default_hide'] = false;
							})

							const un_linked_with_job_products = products.filter(product => { return product.job_link && product.job_link.link_id === null && product.job_link.job });
							const un_linked_without_job_products = products.filter(product => { return product.job_link && product.job_link.link_id === null && !product.job_link.job });
							const linked_products = products.filter(product => { return product.job_link && product.job_link.link_id !== null });
							linked_products.forEach(product => {product['is_default_hide'] = true });

							this.file_detail_products = [...un_linked_with_job_products, ...un_linked_without_job_products, ...linked_products];
						}

						if (data[0].stations) {
							const stations = data[0].stations;

							stations.forEach(station => {
								station['supplier_items'] = station.media_supplier_link ? [station.media_supplier_link.media_supplier] : [];
								station['media_supplier'] = station.media_supplier_link ? station.media_supplier_link.media_supplier : null;
								station['no_data'] = false;
								station['is_default_hide'] = false;
							})

							const un_linked_without_supplier_stations = stations.filter(station => { return !station.media_supplier_link || (station.media_supplier_link && !station.media_supplier_link.media_supplier) });
							const linked_stations = stations.filter(station => { return station.media_supplier_link && station.media_supplier_link.media_supplier });
							linked_stations.forEach(station => { station['is_default_hide'] = true });
							this.file_detail_stations = [...un_linked_without_supplier_stations, ...linked_stations];
						}
					} else {
						this.error_msg = reason;
					}
				})
				.catch(e => {
					this.error_msg = e.message;
				})
				.finally(() => {
					if (!clicked_item) {
						this.match_codes_loading = false;
					}
				});
		},
		onJobSearch(val, item) {
			val && (item.job_link && item.job_link.job ?  val !== item.job_link.job.display_name : true) && this.jobQuery(val, item);
		},
		jobQuery(key, item) {
			const params = [];
			params.push("code_and_name=" + encodeURIComponent(key));

			let url = "/api/jobs";
			if (params.length > 0) {
				url+= "?" + params.join('&');
			}

			axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const {status, data, reason } = val.data;
					if (status == "OK") {
						const code_data = data.filter(d => { 
							const code_lowercase = d.code.toLowerCase();
							const key_lowercase = key.toLowerCase();
							return code_lowercase.includes(key_lowercase);
						});
						const desc_data = data.filter(d => { 
							const code_lowercase = d.code.toLowerCase();
							const key_lowercase = key.toLowerCase();
							return !code_lowercase.includes(key_lowercase);
						});

						const data_filter = [...code_data, ...desc_data];

						const job_items = data_filter.map(d => {
							const description = d.display_name.length > DescriptionLimit
								? d.display_name.slice(0, DescriptionLimit) + '...'
								: d.display_name;

							const obj = {
								id: d.id,
								display_name: description,
								acc_dir: d.acc_dir,
								acc_exec: d.acc_exec,
								job_type: d.job_type,
								currency_id: d.currency.id,
								currency: d.currency,
								disabled: false
							};

							return obj;
						});

						const file_detail_products = JSON.parse(JSON.stringify(this.file_detail_products));
						file_detail_products.forEach(prod => {
							if (prod.id === item.id) {
								prod.job_items = job_items;
								prod.no_data = job_items.length === 0 ? true : false;
							}
						});
						this.file_detail_products = [];
						this.file_detail_products = file_detail_products;
					} else {
						this.error_msg = this.errorMessageFormat(reason);
					}
				})
				.catch(e => {
					this.error_msg = this.errorMessageFormat(e.message);
				})
				.finally(() => {
				});
		},
		onJobChange(job, item) {
			const file_detail_products = JSON.parse(JSON.stringify(this.file_detail_products));
			file_detail_products.forEach(prod => {
				if (prod.id === item.id) {
					prod.job_link.job = job;
					prod.no_data = false;
				}
			});
			this.file_detail_products = [];
			this.file_detail_products = file_detail_products;
		},
		onSupplierSearch(val, item) {
			val && (item.media_supplier_link ?  val !== item.media_supplier_link.display_name : true) && this.supplierQuery(val, item);
		},
		supplierQuery(key, item) {
			let url = `/api/addressbook/supplier`;

			const params = [];
			params.push("name=" + key);
			params.push("include_media=" + true);
			params.push("include_normal=" + false);
			
			if (params.length > 0) {
				url+= "?" + params.join('&');
			}

			axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then(val => {
					const {status, data, reason} = val.data;

					if (status === "OK") {
						const file_detail_stations = JSON.parse(JSON.stringify(this.file_detail_stations));

						file_detail_stations.forEach(station => {
							if (station.id === item.id) {
								station.supplier_items = data;
								station.no_data = data.length === 0 ? true : false;
							}
						});
						this.file_detail_stations = [];
						this.file_detail_stations = file_detail_stations;

					} else {
						this.error_msg = reason;
					}
				})
				.catch(e => {
					this.error_msg = e.message;
				})
				.finally(() => {
					this.supplier_loading = false;
				});
		},
		onSupplierChange(supplier, item) {
			const file_detail_stations = JSON.parse(JSON.stringify(this.file_detail_stations));

			file_detail_stations.forEach(station => {
				if (station.id === item.id) {
					station.media_supplier = supplier;
					station.no_data = false;
				}
			});
			this.file_detail_stations = [];
			this.file_detail_stations = file_detail_stations;
		},
		onJobProductLink(item) {
			const params_obj = [];
			params_obj.push("job_id=" + item.job_link.job.id);
			params_obj.push("network_code=" + this.file_detail.network_code);
			params_obj.push("product_code=" + item.job_link.product_code);
			
			let url = '/api/media/media_planning/import_export/check_job_product_link_exists';
			if (params_obj.length > 0) {
				url+= "?" + params_obj.join('&');
			}

			axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const json = val.data;

					const { status, data, reason } = json;

					if (status == "OK") {
						if (!data) {
							this._onJobProductLink(item);
						} else {
							this.notice_text = [];
							this.notice_text = [Exist_Text];
							this.visible_notice = true;
						}
					} else {
						if (reason === 'Link already exists') {
							this.notice_text = [];
							this.notice_text = [reason];
							this.visible_notice = true;
						} else {
							this.error_msg = reason;
						}
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
				})
				.finally(() => {
				});
		},
		_onJobProductLink(item) {
			const url = '/api/media/media_planning/import_export/product_link';

			const params_obj = {
				job_id: item.job_link.job.id,
				network_code: this.file_detail.network_code,
				product_code: item.job_link.product_code,
				product_name: item.job_link.product_name
			};

			axios
				.post(url, params_obj, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const json = val.data;

					const { status, reason } = json;

					if (status == "OK") {
						this.getForMatches(this.fileId, item);
					} else {
						if (reason === 'Link already exists') {
							this.notice_text = [];
							this.notice_text = [reason];
							this.visible_notice = true;
						} else {
							this.error_msg = reason;
						}
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
				})
				.finally(() => {
				});
		},
		onUpdateJobProductLink(item) {
			const params_obj = [];
			params_obj.push("job_id=" + item.job_link.job.id);
			params_obj.push("network_code=" + this.file_detail.network_code);
			params_obj.push("product_code=" + item.job_link.product_code);
			params_obj.push("ignore_link_id=" + item.job_link_orginal.link_id);
			
			let url = '/api/media/media_planning/import_export/check_job_product_link_exists';
			if (params_obj.length > 0) {
				url+= "?" + params_obj.join('&');
			}

			axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const json = val.data;

					const { status, data, reason } = json;

					if (status == "OK") {
						if (!data) {
							this._onUpdateJobProductLink(item);
						} else {
							this.notice_text = [];
							this.notice_text = [Exist_Text];
							this.visible_notice = true;
						}
					} else {
						if (reason === 'Link already exists') {
							this.notice_text = [];
							this.notice_text = [reason];
							this.visible_notice = true;
						} else {
							this.error_msg = reason;
						}
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
				})
				.finally(() => {
				});
		},
		_onUpdateJobProductLink(item) {
			const url = `/api/media/media_planning/import_export/product_link/${item.job_link_orginal.link_id}`;

			const params_obj = {
				job_id: item.job_link.job.id,
				network_code: this.file_detail.network_code,
				product_code: item.job_link.product_code,
				product_name: item.job_link.product_name
			};

			axios
				.put(url, params_obj, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const json = val.data;

					const { status, reason } = json;

					if (status == "OK") {
						this.getForMatches(this.fileId, item);
					} else {
						if (reason === 'Link already exists') {
							this.notice_text = [];
							this.notice_text = [reason];
							this.visible_notice = true;
						} else {
							this.error_msg = reason;
						}
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
				})
				.finally(() => {
				});
		},
		onStationLink(item) {
			if (item.media_supplier_link && item.media_supplier_link.station_link_id !== 0) {
				this.onUpdateStationLink(item);
			} else {
				const params_obj = {
					supplier_id: item.media_supplier.id,
					network_code: this.file_detail.network_code,
					network_desc: this.file_detail.network,
					station_code: item.code,
					station_desc: item.description,
					call_sign: '',
					market: '',
					notes: ''
				};

				const url = '/api/media/media_planning/import_export/station_link';

				axios
					.post(url, params_obj, {
						headers: {
							"Authorization": "Bearer " + this.$store.state.token,
							"Accept": "application/json"
						}
					})
					.then((val) => {
						const json = val.data;

						const { status, reason } = json;

						if (status == "OK") {
							this.getForMatches(this.fileId, item);
						} else {
							this.error_msg = reason;
						}
					})
					.catch((e) => {
						this.error_msg = e.message;
					})
					.finally(() => {
					});
			}
		},
		onUpdateStationLink(item) {
			const params_obj = {
				supplier_id: item.media_supplier.id,
				network_code: this.file_detail.network_code,
				network_desc: this.file_detail.network,
				station_code: item.code,
				station_desc: item.description,
				call_sign: '',
				market: '',
				notes: ''
			};

			const url = `/api/media/media_planning/import_export/station_link/${item.media_supplier_link.station_link_id}`;

			axios
				.put(url, params_obj, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const json = val.data;

					const { status, reason } = json;

					if (status == "OK") {
						this.getForMatches(this.fileId, item);
					} else {
						this.error_msg = reason;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
				})
				.finally(() => {
				});
		},
		errorMessageFormat(msg) {
			if (msg.length !== 0) {

				let msg_str = msg;

				if (msg_str.includes(Error_Flag)) {
					msg_str = (msg_str.split(Error_Flag))[1];
				}
			
				return msg_str;
			}
		},
		_removeMsg() {
			this.error_msg = '';
		},
		close() {
			this.visible_notice = false;
			this.notice_text = [];
		}
	}
}
</script>

<style lang="scss" scoped>
.file-list-title {
  font-family: Roboto;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.5px;
  color: #192A3E;
}
.file-list-text {
  font-family: Roboto;
  font-weight: 500;
  font-size: 14px;
  line-height: 36px;
  letter-spacing: 0.5px;
  color: #192A3E;
}
.table-wrap {
	height: calc(100vh - 210px);
	overflow: auto;
}
.table-wrap-container {
  height: 99%;
}
::v-deep {
	.save-btn.v-btn.v-btn--disabled.v-btn--has-bg {
    background-color: rgba(96, 90, 246, 0.2) !important;
	}
	.save-btn.v-btn.v-btn--disabled {
		color: #FFFFFF !important;
	}
}
</style>
